export default __webpack_public_path__ + "669f6daa8dcbd00c0b174beb4cff1ae7.svg";